(function () {
  var STYLE_ID = 'ciw-la-label-uniform-desktop';
  var MQ_DESKTOP = window.matchMedia('(min-width: 750px)');
  var applyTimer = null;

  function pinUniformStylesLast() {
    if (!MQ_DESKTOP.matches) return;

    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) return;
    if (styleEl !== document.body.lastElementChild) {
      document.body.appendChild(styleEl);
    }
  }

  function scheduleApply() {
    if (applyTimer) window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(function () {
      applyTimer = null;
      pinUniformStylesLast();
      window.setTimeout(pinUniformStylesLast, 100);
      window.setTimeout(pinUniformStylesLast, 400);
    }, 0);
  }

  var EVENTS = [
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:render:submissionMethods',
    'LensAdvizor:prescriptionTypes:rendered',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:addOns:rendered',
    'LensAdvizor:render:uploadForm',
    'ciw-la-upload-rx:enhanced',
    'LensAdvizor:component:DidMount'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleApply);
  });

  if (typeof MQ_DESKTOP.addEventListener === 'function') {
    MQ_DESKTOP.addEventListener('change', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply);
  } else {
    scheduleApply();
  }
})();
